import { AlertButton, AlertController } from "@ionic/angular";

export class AlertUtils {
    private static alertCtrl: AlertController;

    static init(alertCtrl: AlertController) {
        this.alertCtrl = alertCtrl;
    }

    static async confirm(message: string, title: string = '') {
        return this.createAlert(message, title, ['Confirmer']);
    }

    static async cancel(message: string, title: string = '') {
        return this.createAlert(message, title, ['Annuler']);
    }

    static async confirmCancel(message: string, title: string = '', confirmCallback?: () => void, cancelCallback?: () => void) {
        return this.createAlert(message, title, [
            {
                text: 'Annuler',
                handler: cancelCallback || (() => {}),
            },
            {
                text: 'Confirmer',
                handler: confirmCallback || (() => {}),
            }
        ]);
    }

    private static async createAlert(message: string, title: string, buttons: (string|AlertButton)[]) {
        if (!this.alertCtrl) {
            console.error('Alert controller not initialized');
        }
        const alert = await this.alertCtrl.create({
            message,
            header: title,
            buttons: buttons,
        });
        return alert.present();
    }
}
